import * as React from 'react';

const SvgCheckCircleSolid = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 25 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M2.75 12.76c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75-9.75-4.366-9.75-9.75m13.36-1.815a.75.75 0 1 0-1.22-.872l-3.236 4.53-1.624-1.624a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgCheckCircleSolid;
